import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { DonationtypeService } from '../../../../../app/shared/API-Service/services/donationtype.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-donation-type',
  templateUrl: './donation-type.component.html',
  styleUrls: ['./donation-type.component.css']
})
export class DonationTypeComponent implements OnInit {
  Donation_type:object [] = [];
  constructor(private _DonationtypeService:DonationtypeService, private _Router:Router) { }

  ngOnInit(): void {
    this.getdonationtype();
  }

  getdonationtype(){
    this._DonationtypeService.GetDonationType().subscribe((res) => {
      this. Donation_type = res.data
    console.log(this.Donation_type);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }

  update(data){
    this._DonationtypeService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertDonationType']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._DonationtypeService.DeleteDonationType(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getdonationtype();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
